import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';

import HelioRouter from './layout/helioRouter/helioRouter';
import Redirect from './components/redirect/redirect';

const Heliodon = () => {
  return (
    <div id="heliodon">
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Redirect to="https://www.asylum.fr/" />} />
          <Route path=":helioUrl/*" element={<HelioRouter />} ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default Heliodon;